import { CurrencyCode, IsoCountryCode2, getCurrencyWithISO } from '@rbilabs/intl';

export const DEFAULT_PAYMENT_CURRENCY = CurrencyCode.USD;
export const DEFAULT_PAYMENT_CURRENCY_NUMBER =
  getCurrencyWithISO(IsoCountryCode2.US)?.number ?? 840;
export const DEFAULT_PAYMENT_COUNTRY = IsoCountryCode2.US;
